export default "__VITE_ASSET__BfZeN74s__"